var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "v2-outline-scene-category", class: { 'is-current': _vm.activeCategoryNode.id === _vm.category.id } }, [_vm._v("\n  " + _vm._s(_vm.category.name) + "\n")]);
};
var staticRenderFns = [];

export { render, staticRenderFns };